import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import AgregarRetrasos from "views/Modulos/Administracion/Retrasos/AgregarRetrasos.jsx";
import Globales from "utils/Globales";
import { Edit, Close, AddCircle, Search, Clear, Filter9Plus } from "@material-ui/icons";
import ReactLoading from "react-loading";

class Retrasos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      NombreRetraso: '',
      Titulo: '',
      motivosRetrasos: [],
      mensaje: '',
      br: false,
      colorNotificacion: 'success',
      errorNombreRetraso: false,
      motivosRetrasosMostrar: [],
      entroFiltrar: false,
      notificacion: false
    };
    //Variable global para indicar el total de registros que se obtendra de la base de datos
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.eventoModalEliminar = this.eventoModalEliminar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.eliminarRetraso = this.eliminarRetraso.bind(this);
    this.filtrarRetraso = this.filtrarRetraso.bind(this);
    this.seleccionado = {};
  }

  componentDidMount() {
    this.obtenerMotivosRetrasos();
    this.obtenerAllMotivosRetrasos();
  }

  //Obtener todos los registros guardados
  obtenerAllMotivosRetrasos() {
    fetch(Globales.Url + 'Retrasos/Retrasos/', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {
      //console.log("🍺 / file: Retrasos.jsx / line 62 / data", data)
        if (data.error) { //Error al obtener los registros
          this.setState({ motivosRetrasos: [] });
        } else { //Obtuvo los registros correctamente
          this.setState({ motivosRetrasos: data.data });
        }
      });
  }

  //Obtener el total de registros que se indican
  obtenerMotivosRetrasos() {
    fetch(Globales.Url + 'Retrasos/Retrasos/ListaRetrasos', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ Fin: global.Fin })
    }
    ).then(res => {
      global.response = res.status;
      res.json()
        .then(data => {
          if (data.error) { //Error al obtener los registros
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else { //Obtuvo los registros correctamente
            //console.log(data);
            this.setState({ motivosRetrasosMostrar: data.data });
          }
        })
        .catch(err => console.error(err));
    });
  }

  //Función de editar registro
  editarMotivoRetraso(id, Nombre) {
    this.setState({ _id: id, NombreRetraso: Nombre, op: 1, showAgregar: true, Titulo: "Editar Motivo de Retraso" });
  }

  //Función de eliminar registro
  eliminarRetraso(id) {
    fetch(Globales.Url + 'Retrasos/Retrasos/BajaRetraso', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ _id: id })
    }
    ).then(res => res.json())
      .then(data => {
        if (data.error) {//Error al obtener los registros
          this.setState({ colorNotificacion: 'danger' });
        } else {//Obtuvo los registros correctamente
          this.setState({ colorNotificacion: 'success' });
        }
        this.setState({ mensaje: data.mensaje, show: false });
        this.showNotification("tr");
        this.obtenerMotivosRetrasos();
        this.limpiar();
      });
  }

  //Función para el evento de eliminar
  deleteEvent = (values) => {
    this.seleccionado = values;
    this.setState({ show: true });
  }

  //Función para habilitar el modal de eliminar
  eventoModalEliminar(e) {
    if (!e) {
      this.setState({ show: false });
      return;
    }
    //Eliminar el elemento
    this.eliminarRetraso(this.seleccionado);
  }

  //Función para abrir el modal de agregar registro
  openModalAgregarRetraso = () => {
    this.setState({ showAgregar: true, Titulo: "Nuevo Motivo de Retraso", op: 0 });
  }

  //Función que recupera valores para el modal de agregar
  eventoModalRetraso = (mensaje, colorNotificacion) => {
    //Cambiar valores por default
    this.setState({ showAgregar: false, Titulo: "Nuevo Motivo de Retraso", NombreRetraso: "", op: 0 })
    this.obtenerMotivosRetrasos();
    this.obtenerAllMotivosRetrasos();
    this.limpiar();
    //Validar que el mensaje venga diferente de vacio
    if (mensaje !== 'esc') {
      this.setState({ mensaje: mensaje, colorNotificacion: colorNotificacion })
      this.showNotification();
    }
  }

  //Función que habilita la notificación
  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false, notificacion: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  //Función para obtener el texto de los inputs
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  //Función para realizar el filtrado de búsqueda
  filtrarRetraso() {
    var valor1 = 0;
    //Validar que el input no este vacio
    if (this.state.NombreRetraso.trim() == '') {
      this.setState({ errorNombreRetraso: true, colorNotificacion: 'danger', mensaje: "Complete el campo de búsqueda", NombreRetraso: '' });
      valor1 = 1;
    } else {
      this.setState({ errorNombreRetraso: false });
      valor1 = 0;
    }
    //Validar si hay campos requeridos
    if (valor1 > 0) { //Hay campos requeridos
      this.showNotification();
    } else { //No hay campos requeridos
      fetch(Globales.Url + 'Retrasos/Retrasos/FiltrarRetraso', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        }
        , body: JSON.stringify({NombreRetraso:this.state.NombreRetraso})
      }
      ).then(res => res.json())
        .then(data => {
        //console.log("TCL: Retrasos -> filtrarRetraso -> data", data)
          if (data.error) { //Error en la respuesta
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else if (data.data.length == 0) { //Ninguna coincidencia
            this.setState({ colorNotificacion: "warning", motivosRetrasosMostrar:[], mensaje: "No hay ninguna coincidencia", entroFiltrar: true })
            this.showNotification();
          } else { //Filtrado exitoso
            this.setState({ colorNotificacion: 'success', motivosRetrasosMostrar: data.data, entroFiltrar: true })
          }
        })
        .catch(err => console.error(err));
    }
  }

  //Función para volver los valores por default
  limpiar() {
    this.setState({ NombreRetraso: '', entroFiltrar: false });
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.obtenerMotivosRetrasos();
    this.obtenerAllMotivosRetrasos();
  }

  //Función para mostrar mas registros en la tabla
  verMas() {
    //Validar si entro a filtrar
    if (this.state.entroFiltrar) {
      this.limpiar();
    } else {
      //Creando variable con mas valor que la variable global
      var num = global.Fin + 5;
      var mostrarMensaje = false;
      if(this.state.motivosRetrasos.length <= global.Fin){
        mostrarMensaje = true;
      }
      //Validación de el valor de la variable global sea menor o igual que el total de registros obtenidos
      if (num <= this.state.motivosRetrasos.length && global.entrar) {
        //Cambiando el valor de la variable global
        global.Fin = num;
        //Obteniendo el número de registros requeridos
        this.obtenerMotivosRetrasos();  
      };
      //Validación de que el número total de registros requiridos sea mayor al total de registros y cambio de valor de variables
      if (num > this.state.motivosRetrasos.length && global.entrar) {
        //Cambiando el valor de la variable para que no vuelva a traer mas registros
        global.entrar = false;
        //Cambiando el valor de la variable global
        global.Fin = this.state.motivosRetrasos.length;
        //Obteniendo el total de los registros requeridos
        this.obtenerMotivosRetrasos();
      };
      //Validación de que ya no hay mas registros que mostrar
      if (mostrarMensaje) {
        this.setState({ mensaje: 'No hay más motivos de retrasos para mostrar', colorNotificacion: 'warning' });
        this.showNotification();
      };
    }
  }
  

  render() {
    let agregar;
    if (this.state.showAgregar == true) {
      agregar =
        <AgregarRetrasos
          Titulo={this.state.Titulo}
          NombreRetraso={this.state.NombreRetraso}
          _id={this.state._id}
          showAgregar={this.state.showAgregar}
          eventClick={this.eventoModalRetraso}
          op={this.state.op}
        />
    }
    const { classes } = this.props;
    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info" text>
                <h4 className={classes.cardTitle}>Motivos de Retrasos</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Buscar motivo de retraso"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        onChange: this.handleChange,
                        value: this.state.NombreRetraso,
                        name: "NombreRetraso",
                        id: "NombreRetraso",
                        type: "text",
                        error: this.state.errorNombreRetraso
                      }}
                      className="mt-5"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="info" round onClick={() => this.filtrarRetraso()}><Search />Buscar</Button>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="danger" round onClick={() => this.limpiar()}><Clear />limpiar</Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="info" round onClick={() => this.verMas()}><Filter9Plus />Ver Más</Button>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="success" round onClick={() => this.openModalAgregarRetraso()}><AddCircle />Agregar</Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          {/* Tabla de motivosRetrasos */}
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <h4 className="pull-left">Lista de Motivos de Retrasos</h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                {global.response === 200 ?
                  <div className="table-wrapper-scroll-y">
                    <table className="col-xs-12 col-sm-12 col-md-12">
                      <thead>
                        <th className="center">Nombre Retrasos</th>
                        <th className="pull-right">Acciones</th>
                      </thead>
                      <tbody>
                        {this.state.motivosRetrasosMostrar.map(Retrasos => {
                          return (
                            <tr key={Retrasos._id}>
                              <td>{Retrasos.NombreRetraso}</td>
                              <td className="pull-right">
                                <Button color="warning" round justIcon size="sm" onClick={() => this.editarMotivoRetraso(Retrasos._id, Retrasos.NombreRetraso)}><Edit /></Button>
                                <Button color="danger" round justIcon size="sm" onClick={() => this.deleteEvent(Retrasos._id)}><Close /></Button>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div> :
                  <GridContainer justify='center'>
                    <ReactLoading type={'bubbles'} color={'#CFCFCF'} height={'10%'} width={'10%'} />
                  </GridContainer>
                }

              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div id="">
          <ModalPregunta
            Titulo={"Eliminar Motivo de Retraso"}
            Cuerpo={"¿Está seguro que desea eliminar el motivo de retraso?"}
            show={this.state.show}
            eventClick={this.eventoModalEliminar}
          />
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    )
  }
}

export default withStyles(headerLinksStyle)(Retrasos);